import { ActivateAlly } from '@components/hub/allies/ActivateAlly';
import { UpgradeAlly } from '@components/hub/allies/UpgradeAlly';
import { AllyLevel } from '@components/hub/allies/AllyLevel';
import { HoverMenu } from '@components/helpers/HoverMenu';
import { IconAlertTriangle } from '@tabler/icons-react';
import { useAppStore, UserData } from '@stores';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

export function Allies() {
  const [supportAlly, setSupportAlly] = useState('');
  const [upgradeAlly, setUpgradeAlly] = useState('');

  const { t } = useTranslation(undefined, { keyPrefix: 'Hub.Allies' });
  const { userData } = useAppStore();

  const hoverItems = (ally: UserData['allies'][0]) => [
    {
      label: 'Support',
      visible: !ally.active,
      className: 'btn-active mx-6',
      onClick: () => setSupportAlly(ally.id)
    },
    {
      label: 'Upgrade', 
      className: 'mx-6',
      onClick: () => setUpgradeAlly(ally.id)
    },
  ];

  const notSupporting = !userData.allies.some((ally) => ally.active);

  return (
    <div>
      <ActivateAlly onClose={() => setSupportAlly('')} allyId={supportAlly} />
      <UpgradeAlly onClose={() => setUpgradeAlly('')} allyId={upgradeAlly} />

      <div className="flex items-center justify-between mt-6 px-2">
        <p className="text-lg">{t('allies')}</p>
      </div>

      {notSupporting && (
        <div className="flex items-center px-2 mb-1 text-red-500 flashing">
          <IconAlertTriangle size={13} />
          <p className="text-sm ml-1">{t('notSupporting')}</p>
        </div>
      )}

      <div className="flex w-screen overflow-x-auto mb-6 mt-1 tutorial-allies">
        {userData.allies.map((ally) => (
          <HoverMenu className="ally-container" items={hoverItems(ally)} key={ally.id}>
            <img src={`/img/allies/${ally.type.toLowerCase()}.avif`} className="absolute inset-0 object-cover" />
            <div className="absolute inset-0 grid-overlay" />
            <div className="absolute inset-0 bg-gradient-to-b from-black/20 to-black" />

            <div className="absolute inset-0 flex flex-col justify-between">
              <div>
                <div className="flex justify-between">
                  <p className="text-lg font-bold px-1.5">
                    {t(`${ally.type}.name`)}
                  </p>
                  <div className="flex items-center">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <div className={`${ally.rank > i && 'active'} ally-rank`} key={i} />
                    ))}
                  </div>
                </div>

                {ally.active && (
                  <p className="ally-supporting btn-active">{t('currentlySupporting')}</p>
                )}
              </div>
              <div>
                <div className="p-1.5">
                  <p className="text-xs italic">
                    {t(`${ally.type}.description`)}
                  </p>

                  <p className="text-xs mt-1 text-gray-400">
                    {t(`${ally.type}.buff`)}
                  </p>
                </div>

                <AllyLevel xp={ally.xp || 2} rank={ally.rank} />

                <p className="bg-tertiary border-t border-secondary p-1 text-center text-sm">
                  {t(`${ally.type}.rank${ally.rank}`)}
                </p>
              </div>
            </div>
          </HoverMenu>
        ))}
      </div>
    </div>
  );
}